var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPrivatesale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_101_1148)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6001,
    r: 20,
    fill: "url(#paint0_linear_101_1148)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6001,
    r: 20,
    fill: "url(#paint1_linear_101_1148)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6001,
    r: 17.5,
    stroke: "url(#paint2_linear_101_1148)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.6001,
    r: 17.5,
    stroke: "url(#paint3_linear_101_1148)",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2674 30.5034C23.9764 30.0524 24.6874 29.6036 25.3963 29.1527C25.7172 28.9492 26.0423 28.7479 26.3548 28.5297C27.0973 28.0117 27.7936 27.4223 28.4124 26.7595C29.6373 25.4444 30.5685 23.886 31.1579 22.1892C31.6382 20.8028 31.8438 19.341 31.8438 17.877V15.0853C31.8438 14.7099 31.5816 14.3827 31.2271 14.2757C30.9712 14.1981 30.7174 14.1184 30.472 14.0156C30.5392 14.0429 30.6063 14.0722 30.6734 14.0995C30.235 13.9128 29.8239 13.6737 29.4464 13.3843L29.6163 13.5164C29.243 13.227 28.9074 12.8935 28.6179 12.5202L28.7501 12.6901C28.4606 12.3125 28.2194 11.8993 28.0328 11.461C28.06 11.5281 28.0894 11.5952 28.1166 11.6623C28.0537 11.5113 27.995 11.3561 27.9447 11.2009C27.8314 10.8464 27.5147 10.5843 27.1351 10.5843H19.6074C19.2614 10.5843 18.9132 10.5738 18.5671 10.5843H18.5524C18.1707 10.5843 17.8561 10.8464 17.7428 11.2009C17.6925 11.3582 17.6359 11.5113 17.5709 11.6623C17.5981 11.5952 17.6275 11.5281 17.6548 11.461C17.4681 11.8993 17.2269 12.3104 16.9374 12.6901L17.0696 12.5202C16.7801 12.8935 16.4445 13.227 16.0712 13.5164L16.2411 13.3843C15.8636 13.6737 15.4504 13.9128 15.0141 14.0995C15.0812 14.0722 15.1483 14.0429 15.2155 14.0156C14.968 14.1184 14.7163 14.1981 14.4604 14.2757C14.1059 14.3827 13.8438 14.7099 13.8438 15.0853V17.6148C13.8438 18.0594 13.8438 18.5041 13.8752 18.9487C13.9423 19.8527 14.0954 20.7546 14.3492 21.625C14.8526 23.3533 15.7251 24.9452 16.8829 26.319C17.7827 27.3866 18.8671 28.2508 20.0416 28.9953L22.3634 30.4677C22.3823 30.4803 22.4033 30.4929 22.4222 30.5055C22.7934 30.7404 23.3639 30.5957 23.5695 30.2035C23.7876 29.7882 23.6638 29.3079 23.2674 29.0562C22.8899 28.8171 22.5124 28.578 22.1369 28.3389C21.6545 28.0326 21.1742 27.7285 20.6918 27.4223C20.3541 27.2083 20.0248 26.9797 19.706 26.7364L19.8759 26.8686C19.0831 26.254 18.37 25.5409 17.7554 24.7481L17.8876 24.918C17.2625 24.1063 16.7424 23.217 16.3418 22.2731C16.369 22.3403 16.3984 22.4074 16.4257 22.4745C16.0167 21.5034 15.7377 20.484 15.5972 19.4395C15.6077 19.5129 15.6182 19.5884 15.6266 19.6619C15.5364 18.9823 15.5217 18.3027 15.5217 17.6211V15.0937C15.3161 15.3643 15.1106 15.6327 14.905 15.9033C15.6286 15.6852 16.3292 15.3957 16.9437 14.9532C17.6715 14.4288 18.2924 13.7828 18.7538 13.011C19.0076 12.5873 19.211 12.1258 19.362 11.656C19.0915 11.8616 18.823 12.0671 18.5524 12.2727H26.0801C26.4261 12.2727 26.7743 12.2811 27.1204 12.2727H27.1351C26.8645 12.0671 26.596 11.8616 26.3255 11.656C26.8519 13.2983 28.0474 14.7266 29.6163 15.4649C29.9938 15.6432 30.3819 15.7816 30.7825 15.9033C30.5769 15.6327 30.3714 15.3643 30.1658 15.0937V18.0678C30.1658 18.6006 30.1302 19.1333 30.0609 19.6619C30.0714 19.5884 30.0819 19.5129 30.0903 19.4395C29.9477 20.4819 29.6687 21.5034 29.2618 22.4745C29.2891 22.4074 29.3185 22.3403 29.3457 22.2731C28.9451 23.217 28.425 24.1063 27.7999 24.918L27.9321 24.7481C27.3175 25.5409 26.6044 26.254 25.8116 26.8686L25.9815 26.7364C25.5117 27.0993 25.0125 27.4118 24.5133 27.7306C23.9596 28.083 23.4059 28.4332 22.8521 28.7856C22.7095 28.8758 22.5648 28.9681 22.4222 29.0583C22.2397 29.1736 22.095 29.3477 22.0362 29.5595C21.9817 29.7609 22.0069 30.0273 22.1201 30.2056C22.3592 30.5747 22.871 30.7551 23.2674 30.5034Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5691 20.5594L20.7231 22.7135L21.0293 23.0197C21.3502 23.3406 21.8956 23.3406 22.2165 23.0197L23.8797 21.3564L26.512 18.7242L27.1181 18.118C27.4285 17.8076 27.4516 17.2371 27.1181 16.9309C26.7825 16.6226 26.2624 16.5995 25.931 16.9309L24.2677 18.5941L21.6355 21.2264L21.0293 21.8325H22.2165L20.0624 19.6785L19.7562 19.3723C19.4458 19.0619 18.8753 19.0388 18.5691 19.3723C18.2608 19.7079 18.2377 20.2259 18.5691 20.5594Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_101_1148",
    x: 0.847312,
    y: 0.600098,
    width: 43.9929,
    height: 43.9929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.998219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_1148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_1148",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_101_1148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1148",
    x1: 38.7548,
    y1: 34.8199,
    x2: 26.6622,
    y2: -0.0717284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590159,
    stopColor: "#1A23FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2FFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1148",
    x1: 5.10198,
    y1: 38.3419,
    x2: 40.5855,
    y2: 2.85833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_1148",
    x1: 24.4598,
    y1: 40.6001,
    x2: 42.8267,
    y2: 21.3071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1148",
    x1: 0.84375,
    y1: 3.45724,
    x2: 29.7595,
    y2: 47.6195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPrivatesale);
export default __webpack_public_path__ + "static/media/admin_privatesale.76cac7d722adc3e69f113e7e46873101.svg";
export { ForwardRef as ReactComponent };